import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { translations } from "../lib/i18n";

const LanguageContext = createContext(null);

const LANGS = ["es", "en", "fr"];

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    const saved = localStorage.getItem("agro_lang");
    return LANGS.includes(saved) ? saved : "es";
  });

  useEffect(() => {
    localStorage.setItem("agro_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang,
      toggle: () =>
        setLang((p) => LANGS[(LANGS.indexOf(p) + 1) % LANGS.length]),
      langs: LANGS,
      t: translations[lang],
    }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
